import {CopilotIcon} from '@primer/octicons-react'
import type {CopilotChatModel} from '@github-ui/copilot-chat-types'
import {useState} from 'react'

import styles from './ModelPicker.module.css'

/**
 * Renders a model's vendor logo, falling back to the Copilot icon when the logo
 * is missing or fails to load. Not a reusable UI primitive — it just picks
 * between an image and an existing icon for this picker.
 */
export function ModelIcon({model}: {model: Pick<CopilotChatModel, 'logoURL'>}) {
  const [failed, setFailed] = useState(false)
  if (model.logoURL && !failed) {
    return (
      <img
        className={styles.vendorIcon}
        src={model.logoURL}
        alt=""
        aria-hidden="true"
        width={16}
        height={16}
        onError={() => setFailed(true)}
      />
    )
  }
  return <CopilotIcon size={16} />
}
